import React, {PureComponent} from "react"

import {Wallet, QueryWalletArgs} from "@irati/types"
import Query, {QueryComponentProps} from "@irati/utils/services/apollo/Query"
import DefaultLoader from "@irati/utils/services/apollo/Loading/Loader"

import query from "../../graph/query/wallet"

interface Props extends Omit<QueryComponentProps<{wallet: Wallet}, QueryWalletArgs>, "query"> {}

export default class WalletBallance extends PureComponent<Props> {
  render() {
    const {children, useLoader = true, Loader = DefaultLoader, variables, ...props} = this.props
    const {userId, currency, entityId, entityType} = variables ?? {}
    return (
      <Query
        useLoader={false}
        variables={{
          userId: userId || entityId,
          currency,
          entityType,
          entityId: userId || entityId
        }}
        {...props}
        query={query}>
        {(apollo) => {
          // if useLoader=true, use a custom loader that only shows the loader on first load
          if (apollo.loading && !apollo?.data?.wallet) {
            return useLoader ? <Loader /> : null
          }

          return children(apollo)
        }}
      </Query>
    )
  }
}
